import React from 'react';
import { useGetHousesQuery } from '../drApi/drApi';
import HousesTable from './HousesTable';

const Houses = () => {
  const { isLoading, data } = useGetHousesQuery();
  return <HousesTable isLoading={isLoading} data={data || []} />;
};

export default Houses;
